import PendingPayment from 'app/src/payments/PendingPayment';

/**
 * Class definition for an Adjustment payment. Adjustments are middleware-generated payments used to balance sales due to rounding differences between eCom and Retail.
 */
export default class AdjustmentPayment extends PendingPayment {
  /**
   * Constructor
   * @param amount {Decimal}  The amount of the adjustment
   * @param paymentTypeID {Integer} The Payment Type ID for the Payment
   * @param saleID {Number}   The ID of the sale for the payment
   */
  constructor(amount, paymentTypeID, saleID = 0) {
    super(amount, paymentTypeID, saleID);

    this._allowMultiple = false;
  }
}
